import { gql } from '@apollo/client'

import { LOCATION_LIST_FRAGMENT } from '../fragments'

const UPDATE_LOCATION_MUTATION = gql`
  mutation updateLocation($id: ID!, $data: LocationUpdateInput!) {
    updateLocation(id: $id, data: $data) {
      ...LocationListFragment
    }
  }
  ${LOCATION_LIST_FRAGMENT}
`

export default UPDATE_LOCATION_MUTATION
